<template>
  
  <div class="flex flex-col w-full items-center px-2 lg:pl-20 mb-20 bg-purple100 lg:mb-40">

    <ring-loader v-if="showLoader"></ring-loader>

        <div v-if="playerId == groupInfo.main_player_id" class="flex justify-center items-center mt-2 lg:mt-10 mb-2 lg:mb-10 w-full">
                        
            <label class="me-5"><strong>{{$t('player.groupCode')}} </strong></label>

            <label
            class="me-5 p-2 lg:p-5 bg-blue-300  rounded-lg border-blue-800 border-4">
            {{groupInfo.uuid}}</label>

            <div>

                <button class="text-white  bg-blue-600 rounded lg:rounded-lg font-bold 
                    uppercase px-6 py-2 text-sm outline-none focus:outline-none me-1 mb-1" 
                    type="button" style="transition: all .15s ease" v-on:click="copyCode">
                    <!-- type="button" style="transition: all .15s ease" v-clipboard="codeCopy"> -->
                    {{$t('business.copyCode')}} 
                </button>
            </div>
        </div>

        <div class="flex justify-center items-center mt-2 lg:mt-10 mb-2 lg:mb-10 w-full">
                    
            <label class="me-5"><strong>{{$t('player.groupName')}} </strong></label>

            <label
            class="me-5 p-2 lg:p-5 bg-blue-300  rounded-full border-blue-800 border-4">
            {{groupInfo.name}}</label>
        </div>

        <div v-if="allowEdit" class="flex justify-center items-center mb-10 w-full">
                        
                <input class="me-1 lg:me-2" @click="showFootballPositions=!showFootballPositions" type="checkbox" /> {{$t('player.showFootballDetails')}}
        </div>

    <div class="h-full w-full overflow-x-scroll mb-4 lg:mb-10" :key="showFootballPositions">

        <div v-if="players.length > 0">

            <div class="mt-2 lg:mt-4 mb-2 lg:mb-4">
                <label class="me-5 p-1 lg:p-2 bg-blue-300 rounded-lg border-blue-600 border lg:border-2">
                    {{$t('player.allPlayers')}}</label>
            </div>

            <div class="flex flex-row overflow-y-scroll justify-start">

            <div class="lg:border-2 border border-purple-600 bg-purple-200 w-64 me-2 lg:me-4"
             v-for="(player, i) in allPlayers" :key="i">

                <player-card :groupId="groupInfo.id" :player="player" :playerId="playerId" 
                :showFootballPositions="showFootballPositions" :allowEdit="allowEdit"
                 :switchToTeam="switchToTeam" :mainCard="true" ></player-card>
            </div>
            </div>
        </div>

        <div class="p-1 flex flex-row w-full justify-between">

             <div class="border border-yellow-600 bg-yellow-200 lg:w-2/5 flex flex-col items-center">

                <div class="mt-2 lg:mt-4 mb-2 lg:mb-4">
                    <label class="me-5 p-1 lg:p-2 bg-blue-300 rounded-lg border-blue-600 border lg:border-2">
                    {{$t('player.allTeamOne')}}</label>
                </div>

                <div v-if="teamOnePlayers.length > 0">

                    <div class="mb-2 lg:mb-4" v-for="(player, i) in teamOnePlayers" :key="i">

                        <player-card :groupId="groupInfo.id" :player="player" :playerId="playerId"
                         :showFootballPositions="showFootballPositions" :allowEdit="allowEdit"
                          :switchToTeam="switchToTeam" :mainCard="false" ></player-card>
                    </div>
                </div>
                
            </div>

            <div class="border border-red-600 bg-red-200 w-2/5 flex flex-col items-center">

                <div class="mt-2 lg:mt-4 mb-2 lg:mb-4">
                    <label class="me-5 p-1 lg:p-2 bg-blue-300 rounded-lg border-blue-600 border lg:border-2">
                        {{$t('player.allTeamTwo')}}</label>
                </div>
                
                <div v-if="teamTwoPlayers.length > 0">

                     <div class="mb-2 lg:mb-4" v-for="(player, i) in teamTwoPlayers" :key="i">

                        <player-card :groupId="groupInfo.id" :player="player" :playerId="player.two_player.id"
                        :showFootballPositions="showFootballPositions" :allowEdit="allowEdit"
                         :switchToTeam="switchToTeam" :mainCard="false" ></player-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="h-full w-full overflow-x-scroll overflow-y-scroll mb-30 lg:mb-40">

        <div class="flex w-full justify-center">

            <label> {{$t('player.comingBookings')}}</label>
        </div>
        
        <div v-for="( booking, i) in groupInfo.two_pitch_bookings" :key="i">
            
            <players-group-booking-card :booking="booking" :openMap="openMap" :player="player"
            :reload="reload" :group="groupInfo"/>
        </div>
    </div>
  </div>
</template>

<script>

import playerCard from './PlayerCard';

import twoMyUpdates from '../hasura/myTwoUpdates';

import componentsHelpers from '../classes/componentHelpers';

import PlayersGroupBookingCard from './PlayersGroupBookingCard';


export default {

    mounted(){
        
    // console.log(`this.groupInfo: ${JSON.stringify(this.groupInfo)}`);

        // console.log(`in info`)
        // console.log(`this.playerId: ${this.playerId}`);

        // console.log(`this.groupInfo.main_player_id: ${this.groupInfo.main_player_id}`);

        if(this.playerId == this.groupInfo.main_player_id){

            this.allowEdit = true;
        }

       this.players = this.groupInfo.two_player_to_players_groups;

        // console.log(`this.players: ${JSON.stringify(this.players)}`);

        this.setGroups();
        // console.log(`this.teamOnePlayers: ${JSON.stringify(this.teamOnePlayers)}`);
        // console.log(`this.teamTwoPlayers: ${JSON.stringify(this.teamTwoPlayers)}`);
    },

    props:{

        reload: {

            type: Function
        },

        groupInfo: {

            type: Object
        },

        openMap:{

            type: Function
        },

        playerId: 0,

        player:{

            type: Object
        }
    },
    
    components:{

        playerCard,
        PlayersGroupBookingCard
    },

    methods:{

        setGroups(){

            this.allPlayers = this.players.filter(item => item);

            this.teamOnePlayers = this.players.filter(item => item.team == 1);

            this.teamTwoPlayers = this.players.filter(item => item.team == 2);

            // console.log(`teamOnePlayers: ${JSON.stringify(this.teamOnePlayers)}`);
            // console.log(`teamTwoPlayers: ${JSON.stringify(this.teamTwoPlayers)}`);
        },

        copyCode() {
            
            this.$clipboard(this.groupInfo.uuid);

            // console.log(`copied uuid: ${this.uuid}`);
        },

        getUserId(){

            if(JSON.stringify(this.$userId) != '{}'){

                return this.$userId
            }
            else{

                return 0;
            }
        },

        async switchToTeam(oldTeam, newTeam, playerId, showLoader){

            const userId = this.getUserId();

            try{

                showLoader(true);

                const groupToPlayerUpdateResult = await this.$apollo.mutate({

                    mutation: twoMyUpdates.update_group_to_player,

                    variables: {

                        groupId: this.groupInfo.id,
                        playerId: playerId,
                        team: newTeam
                        // typeId: userType
                    },
                        
                    error(error){

                        showLoader(false)
                        this.mutationError = error;

                        componentsHelpers.sendError(this.$apollo, userId, 'Player', 'playersGroupInfo', 'switchToTeam',
                        error);

                        componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                    }
                });

                if(groupToPlayerUpdateResult.data.update_two_player_to_players_group.affected_rows == 1){

                    this.changePlayer(newTeam, playerId);
                    // this.removePlayer(oldTeam, playerId);

                    // this.addPlayer(newTeam, playerId);
                }
                
                showLoader(false);
            }catch(error){

                showLoader(false);
                componentsHelpers.sendError(this.$apollo, userId, 'Player', 'playersGroupInfo', 'switchToTeam-catchError',
                error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            }   
        },

        changePlayer(newTeam, playerId){

            // console.log(`this.players: ${JSON.stringify(this.players)}`);

            // console.log(`playerId: ${playerId}`);

            this.players.forEach((item, index) => {
                
                if(item.two_player.id == playerId){
                    item.team = newTeam;
                }
            });

            this.setGroups();
        },

         removePlayer(team, playerId){

            if(team == 0){

            }else if(team == 1){


            }else if(team == 2){


            }
        },

        addPlayer(team){

            if(team == 0){


            }else if(team == 1){


            }else if(team == 2){

                
            }
        }
    },

    data(){

        return{

            players: [],
            allPlayers:[],
            teamOnePlayers:[],
            teamTwoPlayers:[],
            uuid: '',
            allowEdit: false,
            showFootballPositions: false,
            showLoader: false,
        }
    }

}
</script>

<style>

</style>